var React = require('react');

function MyProfileAddressIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","style":{"fill":"none"},"key":0}),React.createElement("g",{"id":"_01_align_center","key":1},[React.createElement("path",{"id":"Path_6994","d":"M10,19l-.5-.4c-.7-.6-7-6-7-10,0-4.2,3.3-7.6,7.4-7.6,4.2,0,7.6,3.3,7.6,7.4,0,0,0,.1,0,.2,0,4-6.3,9.4-7,10l-.5.4ZM10,2.7c-3.3,0-5.9,2.6-5.9,5.9,0,2.5,3.9,6.5,5.9,8.3,2-1.8,5.9-5.8,5.9-8.3,0-3.3-2.6-5.9-5.9-5.9h0Z","style":{"fill":"#5b6070"},"key":0}),React.createElement("path",{"id":"Path_6995","d":"M10,11.6c-1.6,0-3-1.3-3-3s1.3-3,3-3,3,1.3,3,3h0c0,1.6-1.3,3-3,3ZM10,7.1c-.8,0-1.5.7-1.5,1.5,0,.8.7,1.5,1.5,1.5.8,0,1.5-.7,1.5-1.5h0c0-.8-.7-1.5-1.5-1.5h0Z","style":{"fill":"#5b6070"},"key":1})])]);
}

MyProfileAddressIcon.defaultProps = {"id":"Layer_1","width":"20","height":"20","version":"1.1","viewBox":"0 0 20 20"};

module.exports = MyProfileAddressIcon;

MyProfileAddressIcon.default = MyProfileAddressIcon;
